module.exports = __webpack_public_path__ + "img/Avatar-84.f9c9c3d2.svg";